import React from 'react';

const EventGuide = () => {
    return (
      <div className="container col-md-8 col-lg-6">
        <p className="text-fz-14px text-fw-normal text-black-333 mb-2 mt-5">
          禁止されている
          <a
            href="https://tunagate.com/articles/faq/make-events/event-create-rule"
            target="_blank"
            rel="noreferrer"
            className="text-primary d-inline-block"
          >
            行為
          </a>および<a
            href="https://tunagate.com/articles/faq/make-events/event-create-rule"
            target="_blank"
            rel="noreferrer"
            className="text-primary d-inline-block"
          >
            イベント内容
          </a>を必ずご確認ください。また、
          <a
            href="https://tunagate.com/article/rules"
            target="_blank"
            rel="noreferrer"
            className="text-primary d-inline-block"
          >
            利用規約
          </a>
          および
          <a
            href="https://tunagate.com/articles/rules/guidelines/privacypolicy"
            target="_blank"
            rel="noreferrer"
            className="text-primary d-inline-block"
          >
            プライバシーポリシー
          </a>
          に同意の上、「イベントを公開する」ボタンを押してください。
        </p>
      </div>
    );
  };

export default EventGuide;
